export function getIsDevEnvironment(): boolean {
  let hostname;
  if (typeof window !== "undefined") {
    // eslint-disable-next-line no-undef
    hostname = window.location.hostname;
  }
  return hostname === "localhost";
}
